import {ChoiceGroup, DetailsList, SearchBox, Selection, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddTransactionInvoice from "../Panel/TransactionInvoice/AddTransactionInvoice";
import {MoneyField} from "../Utilities/MoneyField";
import {useOutletContext} from "react-router-dom";
import { netGrossColumn, useNetGross } from "../Utilities/NetGrossField";

function InvoiceTodo(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [invoiceTodos, setInvoiceTodos] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [filtered, setFiltered] = useState([]);
    const [filter, setFilter] = useState('');
    const [type, setType] = useState('addons');
    const [selectedItems, setSelectedItems] = useState([])
    const selection = new Selection({
        onSelectionChanged: () => {
            if (selection.getSelectedCount()) {
                setFilter(selection.getSelection()[0].project_id);
            }
            setSelectedItems(selection.getSelection())
        }
    })

    const options = [
        {key: 'addons', text: 'Dodatki', iconProps: {iconName: 'WebAppBuilderFragment'}},
        {key: 'fees', text: 'Opłaty', iconProps: {iconName: 'Money'}}
    ];

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/transaction/invoice/todo", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setInvoiceTodos(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh]);
    const [addInvoice, setAddInvoice] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        if(selectedItems.length) {
            actions([
                {
                    key: 'addInvoiceTodo',
                    text: 'Dodaj Fakturę',
                    iconProps: { iconName: 'Add' },
                    onClick: () => setAddInvoice({items: selectedItems, type: type})
                }
            ]);
        }
        return actions;
    }, [selectedItems]);

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
            {
                key: 'project',
                name: 'Projekt',
                ariaLabel: 'Projekt',
                fieldName: 'project',
                minWidth: 210,
                maxWidth: 210,
                isRowHeader: true,
                isResizable: false,
                isSorted: true
            },
            {
                key: 'venture',
                name: 'Kontrakt',
                ariaLabel: 'Kontrakt',
                fieldName: 'venture',
                minWidth: 210,
                maxWidth: 210,
                isResizable: true,
            },
            {
                key: 'person',
                name: 'Klient',
                ariaLabel: 'Klient',
                fieldName: 'person',
                isResizable: true,
            },
            {
                key: 'name',
                name: 'Nazwa',
                ariaLabel: 'Nazwa',
                fieldName: 'name',
                minWidth: 300,
                isResizable: true,
            },
            {
                key: 'invoice_number',
                name: 'FV Koszt',
                ariaLabel: 'Faktura Kosztowa',
                fieldName: 'invoice_number',
                minWidth: 150,
                isResizable: true,
                onRender: (item) => (<span title={item.cost_date}>{item.invoice_number}</span>)
            },
            {
                key: 'quantity',
                name: 'Ilość',
                ariaLabel: 'Ilość',
                fieldName: 'quantity',
                minWidth: 80,
                isResizable: true,
            },
            {
                minWidth: 160,
                ...netGrossColumn('', 'price', 'Cena ')
            },
            {
                minWidth: 160,
                ...netGrossColumn('', 'total', 'Wartość ')
            },
            {
                key: 'deadline',
                name: 'Termin',
                ariaLabel: 'Termin Płatności',
                fieldName: 'deadline',
                isResizable: true
            }
        ]);
    }, [netGross]);


    useEffect(() => {
        let items = invoiceTodos[type];
        if (items === undefined) {
            items = [];
        }
        setFiltered(items.filter(item => {return filter === item.project_id || filter === ''}));
    }, [filter, invoiceTodos, type]);

    return (
        <AppContent title={'Fakturowanie'}>
            <ChoiceGroup selectedKey={type} options={options} onChange={(e, val) => setType(val.key)}/>
            <SearchBox placeholder="Wyszukaj" value={filter} onChange={(e, value) => setFilter(value)} />
            <DetailsList items={filtered} columns={columns} selectionMode={SelectionMode.multiple} selection={selection} selectionPreservedOnEmptyClick={true}/>
            <AddTransactionInvoice add={addInvoice} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddInvoice(false)} />
        </AppContent>
    );
}

export default InvoiceTodo;